<template>
  <LoaderWrapper :state="dataState">
    <router-view></router-view>
  </LoaderWrapper>
</template>

<script>
  import { Vuex } from 'vue-infra';

  import { MODULES_PATHS } from '@/store';
  import { workflowGuardMixin } from '@/mixins';
  import { GETTER_TYPES as WORKATO_CONFIGURATION_GETTER_TYPES } from '@/store/modules/data/workato-configuration/getters';
  import LoaderWrapper from '../common/loader-wrapper';

  const mapGetters = Vuex.mapGetters;

  export default {
    name: 'workflows',
    components: {
      LoaderWrapper,
    },
    mixins: [workflowGuardMixin],
    data() {
      return {};
    },
    computed: {
      ...mapGetters(MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS, {
        dataState: WORKATO_CONFIGURATION_GETTER_TYPES.GET_DATA_STATE,
      }),
    },
  };
</script>
